import { CouponInfo, Plan, PlanType } from '@otter-ai/recall-client';
import { atom } from 'jotai';

export const planTypeAtom = atom<PlanType | null>(null);
export const isEduAtom = atom(false);
export const selectedPlanAtom = atom<Plan | null>(null);
export const clickOutAtom = atom(true);
export const couponInfoAtom = atom<CouponInfo | null>(null);
export const couponInfoErrorAtom = atom<Error | null>(null);
export const couponInputAtom = atom('');
export const isCreateAccountAtom = atom(true);
export const savedPaymentIdAtom = atom<string | null>(null);
export const totalCreditsAtom = atom(0);
export const isLoggingInAtom = atom(false);
export const isBillingAddressDebouncingAtom = atom(false);
export const seatCountIsUpdatingAtom = atom(false);
export const planIsUpdatingAtom = atom(false);
export const trialDaysIsUpdatingAtom = atom(false);
export const couponIsUpdatingAtom = atom(false);
export const shippingAddressIsUpdatingAtom = atom(false);
export const refreshSessionAtom = atom(0);

export const totalLoadingAtom = atom(
  (get) =>
    get(seatCountIsUpdatingAtom) ||
    get(planIsUpdatingAtom) ||
    get(trialDaysIsUpdatingAtom) ||
    get(couponIsUpdatingAtom) ||
    get(shippingAddressIsUpdatingAtom),
);

if (process.env.NODE_ENV === 'development') {
  planTypeAtom.debugLabel = 'planTypeAtom';
  isEduAtom.debugLabel = 'isEduAtom';
  selectedPlanAtom.debugLabel = 'selectedPlanAtom';
  totalLoadingAtom.debugLabel = 'totalLoadingAtom';
  clickOutAtom.debugLabel = 'clickOutAtom';
  couponInfoAtom.debugLabel = 'couponInfoAtom';
  couponInfoErrorAtom.debugLabel = 'couponInfoErrorAtom';
  couponInputAtom.debugLabel = 'couponInputAtom';
  isCreateAccountAtom.debugLabel = 'isCreateAccountAtom';
  savedPaymentIdAtom.debugLabel = 'savedPaymentIdAtom';
  totalCreditsAtom.debugLabel = 'totalCreditsAtom';
  isLoggingInAtom.debugLabel = 'isLoggingInAtom';
  isBillingAddressDebouncingAtom.debugLabel = 'isBillingAddressDebouncingAtom';
  seatCountIsUpdatingAtom.debugLabel = 'seatCountIsUpdatingAtom';
  planIsUpdatingAtom.debugLabel = 'planIsUpdatingAtom';
  trialDaysIsUpdatingAtom.debugLabel = 'trialDaysIsUpdatingAtom';
  couponIsUpdatingAtom.debugLabel = 'couponIsUpdatingAtom';
  shippingAddressIsUpdatingAtom.debugLabel = 'shippingAddressIsUpdatingAtom';
  refreshSessionAtom.debugLabel = 'refreshSessionAtom';
}
